import { COLUMN_WIDTHS } from './constants';

export const getGridColumnDetails = (gridColumn: number) => {
  let lgColumn = 10;
  let lgColumnOffset = 1;
  let mdColumn = 8;
  let mdColumnOffset = 0;
  switch (gridColumn) {
    case COLUMN_WIDTHS.THREE_COLUMNS:
      lgColumn = 10;
      lgColumnOffset = 1;
      mdColumn = 8;
      mdColumnOffset = 0;
      break;
    case COLUMN_WIDTHS.TWO_COLUMNS:
      lgColumn = 6;
      lgColumnOffset = 3;
      mdColumn = 8;
      mdColumnOffset = 0;
      break;
    case COLUMN_WIDTHS.ONE_COLUMN:
      lgColumn = 4;
      lgColumnOffset = 4;
      mdColumn = 4;
      mdColumnOffset = 2;
      break;
    default: {
      lgColumn = 10;
      lgColumnOffset = 1;
      mdColumn = 8;
      mdColumnOffset = 0;
    }
  }
  return { lgColumn, lgColumnOffset, mdColumn, mdColumnOffset };
};

export default {};
